import { useEffect, useRef, useState } from "react";

/**
 * A one-second-tick countdown, started on demand via `start(seconds)`.
 * Used to disable the resend button for `retry_after_seconds` after a
 * CONFIRMATION_RESEND_TOO_SOON response, without a real `sleep`.
 */
export const useCountdown = () => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const start = (seconds) => {
    clearInterval(intervalRef.current);
    setSecondsLeft(seconds);

    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return { secondsLeft, start };
};
